import TopicHeader from "../../../Utilities/TopicHeader";
import DurationSearchHead from "../../../Utilities/DurationSearchHead";
import { useEffect, useState } from "react";
import { format, subDays } from "date-fns";
import { useSelector } from "react-redux";
import { post } from "../../Auths/AuthToken";
import setUiMessage from "../../../Utilities/Tostify";
import Pagination from "../../../Utilities/Pagination";
import ReferralList from "./ReferralList";
import { debounce } from "lodash";
import AddReferralPopup from "./AddReferralPopup";
import ConfirmDialog from "../../../Utilities/ConfirmDialog";

function Referral() {
  const { user } = useSelector((store) => store.auth);
  const [openNewReferralForm, setOpenNewReferralForm] = useState({
    status: false,
    refId: null,
    rptSentId: null,
    patientId: null,
    reportId: null,
  });
  const [limit, setSetLimit] = useState(200);
  const [offset, setSetOfset] = useState(0);
  const [allData, setAllData] = useState([]);
  const [reload, setReload] = useState(false);

  const [referralData, setReferralData] = useState({
    startDate: subDays(new Date(), 7),
    endDate: new Date(),
    filterValue: "7D",
    selectedState: "",
    isDateRange: false,
    provider: { value: "ALL", label: "All Providers" },
    searchTermName: "",
    searchTermChart: "",
    docSent: "ALL",
    refAppTaken: "ALL",
  });

  const [deleteReferral, setDeleteReferral] = useState({
    open: false,
    refId: "",
  });

  useEffect(() => {
    // Prevent calling API when date range is incomplete
    if (
      referralData.isDateRange &&
      (!referralData.startDate || !referralData.endDate)
    )
      return;

    const fetchResults = async () => {
      try {
        const response = await post(
          "api/patient/referral/loadReferralGridView",
          {
            ...referralData,
            loginUserId: user?.id,
            limit,
            offset,
            startDate: referralData.startDate
              ? format(referralData.startDate, "yyyy-MM-dd")
              : "",
            endDate: referralData.endDate
              ? format(referralData.endDate, "yyyy-MM-dd")
              : "",
            provider: referralData.provider?.value || "",
          },
        );

        if (response.status === 200) {
          setAllData(response.data);
        }
      } catch (err) {
        setUiMessage("err", err?.message);
      }
    };

    // Memoize the debounced version so it doesn’t reinitialize on every render
    const debouncedFetch = debounce(fetchResults, 500);

    debouncedFetch(referralData.searchTermChart);

    // Cleanup on unmount
    return () => {
      debouncedFetch.cancel();
    };
  }, [referralData, limit, offset, user?.id, reload]);

  const reopenReferralPopup = (refId, rptSentId, patientId, reportId) => {
    setOpenNewReferralForm({
      status: true,
      refId: refId,
      rptSentId: rptSentId,
      patientId: patientId,
      reportId: reportId,
    });
  };

  const handleDeleteReferral = (refId) => {
    setDeleteReferral({
      open: true,
      refId: refId,
    });
  };

  const confirmDeleteReferral = async () => {
    try {
      if (deleteReferral?.refId) {
        const response = await post("api/CommonTask/deleteReferralRow", {
          refId: deleteReferral.refId,
        });
        if (response.status === 200) {
          setUiMessage("suc", "Referral deleted successfully.");
          setReload(!reload);
          setDeleteReferral({
            open: false,
            refId: "",
          });
        }
      }
    } catch (error) {
      setUiMessage("err", error.message);
    }
  };

  return (
    <div id="referralMaingrid" className="preauth-Maingrid-Pat">
      <TopicHeader title={"Referral:"} />
      <DurationSearchHead
        duration={referralData.filterValue}
        startDate={referralData.startDate}
        endDate={referralData.endDate}
        isDateRange={referralData.isDateRange}
        isProviderDd
        options={allData?.allProviders || []}
        selectedProvider={referralData?.provider}
        setData={setReferralData}
        openPopup={() =>
          setOpenNewReferralForm({
            status: true,
            refId: null,
            rptSentId: null,
            patientId: null,
            reportId: null,
          })
        }
      />
      <div className="intake-paging">
        <Pagination
          totalRecord={Number(allData && allData?.rowCount) || 0}
          onPageChange={(data) => {
            setSetLimit(data[1]);
            setSetOfset(data[0]);
          }}
          offset={offset}
          rowPerPage={limit}
        />
      </div>
      <div className="preauth-Maingrid-Patbdy grid-sec clear-top10 pt-referral-grid">
        <div className="referral-Maingrid-Pat-hdr grid-sec">
          <div className="preauth-Maingrid-Pat-sbhdr flex-sec">
            <span className="pacolm5">Chart#</span>
            <span className="pacolm5">Patient Name</span>
            <span className="pacolm4">Contact Info</span>
            <span className="pacolm5">Patient Address</span>
            <span className="pacolm4">Referring Provider</span>
            <span className="pacolm5">Referred To</span>
            <span className="pacolm5">Date & Urgency</span>
            <span className="pacolm5">Reason for Referral</span>
            <span className="pacolm4">Planed Date</span>
            <span className="pacolm4">Note Status</span>
            <span className="pacolm4">Doc Sent</span>
            <span className="pacolm4">Appointment Status</span>
            <span className="pacolm4">Action</span>
          </div>
          <div
            className="preauth-Maingrid-Pat-sbhdr refrl-sb-child flex-sec"
            style={{ backgroundColor: "unset" }}
          >
            <span
              className="pacolm5"
              style={{ width: "calc(8% - 5px) !important" }}
            >
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                id="chartnumber"
                name="chartnumber"
                value={referralData.searchTermChart || ""}
                onChange={(e) =>
                  setReferralData((prev) => ({
                    ...prev,
                    searchTermChart: e.target.value,
                  }))
                }
              />
            </span>
            <span className="pacolm5">
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                id="patientname"
                name="patientname"
                value={referralData.searchTermName || ""}
                onChange={(e) =>
                  setReferralData((prev) => ({
                    ...prev,
                    searchTermName: e.target.value,
                  }))
                }
              />
            </span>
            <span className="pacolm4"></span>
            <span className="pacolm5"></span>
            <span className="pacolm4"></span>
            <span className="pacolm5"></span>
            <span className="pacolm5"></span>
            <span className="pacolm5"></span>
            <span className="pacolm4"></span>
            <span className="pacolm4"></span>
            <span className="pacolm4">
              <select
                className="inpt-width-nw width100"
                value={referralData.docSent}
                onChange={(e) =>
                  setReferralData((prev) => ({
                    ...prev,
                    docSent: e.target.value,
                  }))
                }
              >
                <option value="ALL">All</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </span>
            <span className="pacolm4">
              <select
                className="inpt-width-nw width100"
                value={referralData.refAppTaken}
                onChange={(e) =>
                  setReferralData((prev) => ({
                    ...prev,
                    refAppTaken: e.target.value,
                  }))
                }
              >
                <option value="ALL">All</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </span>
            <span className="pacolm4"></span>
          </div>
        </div>
        <div className="intake-Maingrid-Pat-sb-bdy qgrid-sec">
          {allData?.referralAllData &&
            allData?.referralAllData.map((item, i) => (
              <div
                key={i}
                className={
                  i % 2 === 0
                    ? "preauth-Maingrid-Pat-bdy-rw flex-sec alt-rw"
                    : "preauth-Maingrid-Pat-bdy-rw flex-sec"
                }
              >
                <ReferralList
                  item={item}
                  handlePopupOpen={reopenReferralPopup}
                  handleDeleteReferral={handleDeleteReferral}
                  handleReload={() => setReload(!reload)}
                />
              </div>
            ))}
        </div>
      </div>
      {openNewReferralForm.status && (
        <AddReferralPopup
          isOpen={openNewReferralForm.status}
          onClose={() =>
            setOpenNewReferralForm({
              status: false,
              refId: null,
              rptSentId: null,
              patientId: null,
              reportId: null,
            })
          }
          handleReload={() => setReload(!reload)}
          refId={openNewReferralForm.refId}
          rptSentId={openNewReferralForm.rptSentId}
          patientId={openNewReferralForm.patientId}
          reportId={openNewReferralForm.reportId}
        />
      )}
      {deleteReferral.open && (
        <ConfirmDialog
          title={`Confirm!`}
          bodytext={`Do you really want to delete this referral data?`}
          closeDialog={() =>
            setDeleteReferral({
              open: false,
              refId: "",
            })
          }
          successDialog={confirmDeleteReferral}
          // sucPrams={sucPrams}
        />
      )}
    </div>
  );
}

export default Referral;
